// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 374) return "static/chunks/374-25f1b46fe73a6d02.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"140":"6053c7e5046f3ffa","239":"25d654dcd9ebc17e","553":"dea20a29ca447610","863":"c30af30a0a57c309","905":"250f79df2e7a0f93"}[chunkId] + ".js";
};